import {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { CHAT_DATA } from "./chatData";
import "./chat.css";

const ChatBoxType2 = forwardRef(function ChatBoxType2(
  { DateVal, titImgClass = "", chatClass = "chat_box4", onFinish, onButton },
  ref
) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleContents, setVisibleContents] = useState([]);
  const chatBoxRef = useRef(null);

  const contents =
    DateVal === "DATA1"
      ? CHAT_DATA.dataArr01
      : DateVal === "DATA2"
      ? CHAT_DATA.dataArr02
      : CHAT_DATA[DateVal] || [];

  /* 🔥 외부에서 resume 호출 가능 */
  useImperativeHandle(ref, () => ({
    resume() {
      setCurrentIndex((prev) => prev + 1);
    },
  }));

  /* =========================
     채팅 자동 진행
  ========================= */
  useEffect(() => {
    if (currentIndex >= contents.length) return;

    const item = contents[currentIndex];

    // 버튼 → 외부 위임 + 정지
    if (item.type === "button") {
      onButton && onButton(item);
      return;
    }

    const t = setTimeout(() => {
      setVisibleContents((prev) => [...prev, item]);
      setCurrentIndex((prev) => prev + 1);
    }, 1000);

    return () => clearTimeout(t);
  }, [currentIndex, contents, onButton]);

  /* =========================
     채팅 div 스크롤
  ========================= */
  useEffect(() => {
    if (!chatBoxRef.current) return;
    chatBoxRef.current.scrollTo({
      top: chatBoxRef.current.scrollHeight,
      behavior: "smooth",
    });
  }, [visibleContents]);

  return (
    <div className={`${chatClass} mt24`} id="chat_box" ref={chatBoxRef}>
      {visibleContents.map((c, i) => {
        if (c.type === "chatInfo_Talk1") {
          return (
            <div
              key={i}
              className={`chatInfo_Talk ${c.marType || ""}`}
              dangerouslySetInnerHTML={{ __html: c.text }}
            />
          );
        }

        if (c.type === "leftCharacter") {
          return (
            <div key={i} className={`chat_b_left ${c.marType || ""}`}>
              <div className="chat_b_l_left mr8">
                <span className={c.chat_icon}></span>
              </div>
              <div className="chat_b_l_right">
                <p className="chat_tit mb4">{c.chat_tit}</p>
                <div
                  className={c.talkType}
                  dangerouslySetInnerHTML={{ __html: c.text }}
                />
              </div>
            </div>
          );
        }

        if (c.type === "left_txt") {
          return (
            <div key={i} className={`chat_b_left ${c.marType || ""}`}>
              <div className="chat_b_l_left mr8" />
              <div className="chat_b_l_right">
                <div
                  className={c.talkType}
                  dangerouslySetInnerHTML={{ __html: c.text }}
                />
              </div>
            </div>
          );
        }

        return null;
      })}
    </div>
  );
});

export default ChatBoxType2;
